function getCategoryColorization(category, lang) {
  let initialCat = category

  var cat = ""

  if(lang === 'de') {
    let arr = initialCat.split(" ")[0]
    cat = arr.split("-")[0]
    cat = cat.charAt(0).toLowerCase() + cat.slice(1)

  }else{
    let categories = [
      ['bergbahnen', 'Cable Cars', 'Funivie', 'Gorske železnice'],
      ['freizeit', 'Leisure and Adventure Offers', 'Offerte per il tempo libero', 'Prosti čas in avantura ponuja'],
      ['museen', 'Museums', 'Musei', 'Muzeji'],
      ['sportangebot', 'Sports', 'Sportivo', 'šport'],
      ['thermen'],
      ['erlebnisbäder', 'Adventure Swimming Baths', 'Parchi acquatici', 'Doživljajsko kopališče'],
      ['naturerlebnisse', 'Nature Experience', 'Experienze naturali', 'Narava izkušnje'],
      ['panoramastrassen', 'Panoramic Roads', 'Strase panoramiche', 'Panoramska ulica'],
      ['schifffahrt', 'Boat Trips', 'Battelli', 'Ladijska vožnja'],
      ['zoo', 'Zoo and zoological gardens', 'Parchi zoologici', 'Zoo in ivalske izkušnje']
    ]

    for (let i = 0; i < categories.length; i++) {
      let x = categories[i].includes(initialCat)

      if(x === true) {
        cat = categories[i][0]
        break
      }
    }

  }
  return cat
}

export {getCategoryColorization}
